import * as fromDatatype from '../../../../../models/datatype-library';
import { PmtStmtEinvoiceLinkDto } from './pmt-stmt-einvoice-link-dto.model';
import { PmtStmtIntGrnLinkDto } from './pmt-stmt-int-grn-link-dto.model';
import { PmtStmtIntPoLinkDto } from './pmt-stmt-int-po-link-dto.model';
import { PmtStmtPeppolLinkDto } from './pmt-stmt-peppol-link-dto.model';
import { PmtStmtXtnDoLinkDto } from './pmt-stmt-xtn-do-link-dto.model';

export class PmtStmtLineDto {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    line_ocr_guid: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    branch_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_delivery_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_delivery_order_doc_hdr_open_amount: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_goods_received_note_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_goods_received_note_doc_hdr_open_amount: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_purchase_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_purchase_order_doc_hdr_open_amount: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_sales_invoice_doc_hdr_open_amount: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_open_amount: fromDatatype.NumericDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    confidence_level: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    xtn_from_peppol_gen_doc_hdr_open_amount: fromDatatype.NumericDatatypeInterface;
    matching_status: fromDatatype.VarcharDatatypeInterface;
    peppolHdrLinks: PmtStmtPeppolLinkDto[];
    internalPoLinks: PmtStmtIntPoLinkDto[];
    supplierDoLinks: PmtStmtXtnDoLinkDto[];
    internalGrnLinks: PmtStmtIntGrnLinkDto[];
    einvoiceLinks: PmtStmtEinvoiceLinkDto[];
  }
  